import request from "@/utils/request.js";

/**
 * 忘记密码获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function forgetPasswordSendCode(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordSendCode",
    method: "post",
    data: params
  });
}
/**
 * 更换密码
 * @param params
 * @returns {AxiosPromise}
 */
export function getTokenByCode(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordVerifyCode",
    method: "post",
    data: params
  });
}
/**
 * token和手机号修改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function forgetPasswordUpdatePassword(params) {
  return request({
    url: "/userService/api/app/userNurse/forgetPasswordUpdatePassword",
    method: "post",
    data: params
  });
}
